import { render } from "./OffcanvasViews.vue?vue&type=template&id=0240664d&ts=true"
import script from "./OffcanvasViews.vue?vue&type=script&lang=ts"
export * from "./OffcanvasViews.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__